// @flow
import JQueryView, { on } from '../../../../common/JQueryView';

declare var $: any;

export default class AbsentMembersView extends JQueryView {
  constructor() {
    super('.simple_form');

    $(window).on('load', () => {
      if ($('#show_absent_members_true').prop('checked')) {
        $('#reason-for-absence-form')
          .removeClass('d-none')
          .addClass('d-block');
      } else {
        $('#reason-for-absence-form')
          .removeClass('d-block')
          .addClass('d-none');
      }
    });
  }

  @on({
    event: 'click',
    selector: '#reason-for-absence-form-true',
  })
  showReasonAbsenceForm() {
    $('#show_absent_members_true').prop('checked', true);
    $('#show_absent_members_false').prop('checked', false);
    $('#reason-for-absence-form')
      .removeClass('d-none')
      .addClass('d-block');
  }

  @on({
    event: 'click',
    selector: '#reason-for-absence-form-false',
  })
  hiddenReasonAbsenceForm() {
    $('#show_absent_members_false').prop('checked', true);
    $('#show_absent_members_true').prop('checked', false);
    $('#reason-for-absence-form')
      .removeClass('d-block')
      .addClass('d-none');
  }
}
